import {doc} from './docs.js';

doc(
    "track",
    {
    },
    "Track object",
    () => 0,
    {
        inlets: 0
    }
);


export const track = (object, trackNumber) => {
    let _trackNumber = trackNumber() - 1;
    let subSequence = object.subSequence;
    if (subSequence.getRootSubSequence) {
        subSequence = subSequence.getRootSubSequence();
    }

    console.log("sub sequence for track=", subSequence);

    let track = subSequence.tracks[_trackNumber % subSequence.tracks.length];
    if (!track) {
        return () => undefined;
    }
    object.id = track.id;
    object.width = 80;
    object.height = 80;
    if (track) {
        object.effect = track;
        track.zObject = object;
    }
    object.needsStart = true;
    object.newAttribute("show-sequencer", false);
    object.newAttribute("send-levels", false, (x) => track.sendLevels(x));
    object.newAttribute("level-smoothness", 0.9, (x) => track.trackMeter.smoothness = x);
    object.newAttribute("volume pattern-locked", true);

    return (msg) => {
        let _trackNumber = trackNumber() - 1;
        let track = subSequence.tracks[_trackNumber];
        if (track) {
            object.effect = track;
            track.zObject = object;
        }
        return undefined;
    };
};

